<template>
    <div
        role="dialog"
        :aria-describedby="describedBy"
        :aria-labelledby="labelledBy"
    >
        <div
            :class="{
                [$style.sideDrawerContent]: true,
                [$style.sideDrawerStandard]: !small && !large && !extraLarge,
                [$style.sideDrawerSmall]: small,
                [$style.sideDrawerLarge]: large,
                [$style.sideDrawerExtraLarge]: extraLarge,
            }"
        >
            <div
                :class="$style.closeIcon"
                tabindex="0"
                role="button"
                aria-label="close dialog"
                @click="close"
                @keyup.enter="close"
                @keydown.esc="close"
                ref="closeIcon"
            >
                <FontAwesomeIcon size="lg" :icon="closeIcon" :class="$style.icon" />
            </div>

            <div v-if="showSlot('header')" :class="$style.header">
                <slot name="header" />
            </div>
            <div v-if="showSlot('message')" :class="$style.message">
                <slot name="message" />
            </div>
            <slot
                v-if="showSlot('content')"
                name="content"
                :class="$style.content"
            />
        </div>
        <div
            :class="$style.sideDrawerMask"
            @click="close"
            @keydown.esc="close"
        />
    </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

export default {
    name: 'SideDrawer',
    components: {
        FontAwesomeIcon,
    },
    props: {
        labelledBy: String,
        describedBy: String,
        small: Boolean,
        large: Boolean,
        extraLarge: Boolean,
    },
    mounted() {
        this.$refs.closeIcon.focus()
    },
    computed: {
        closeIcon() {
            return faTimes
        },
    },
    methods: {
        close() {
            this.$emit('close')
        },
        showSlot(slotName) {
            return Boolean(this.$slots[slotName])
        },
    },
}
</script>

<style module src="./SideDrawer.css" />
